<template>
  <div class="text-center" v-if="canShowModal">
    <v-dialog
      v-model="canShowModal"
      max-width="600"
			persistent
      scrollable
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="warning" class="mr-2">mdi-information</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1">{{ modalData.title }}</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="closeModal()"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
						</div>
						<div class="mt-6">
							<div class="mb-0" v-html="modalData.modal_content"></div>

							<div class="d-flex flex-row justify-space-between">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									v-if="!hideCancel"
									@click="closeModal()"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<v-btn
									depressed
									dark
									color="#959595"
									@click="onConfirm"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Ir a Confirmar</p>
								</v-btn>
							</div>

						</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {confirmUserSchedule} from '@/helpers/api/conversations'

export default {
  name: 'GeneralConfirmationModal',
	props: {
		closeModal: {
			type: Function,
		},
		modalData: {
			type: Object,
			default: null
		}
	},
  data: () => ({
		indexModal: + new Date(),
  }),
  computed: {
		canShowModal(){
			return this.modalData?.status
		},
		hideCancel(){
			return this.modalData?.hideCancelButton
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		}
	},
	watch: {
	},
  mounted(){
  },
  methods: {
		onConfirm(){
			if(this.modalData && this.modalData.is_payment_request && this.modalData.schedule_id){
				if(this.modalData.schedule_id){
					this.$router.replace({ hash: '#schedule' })
					this.$store.commit('crm/setCrmModalScheduleId', this.modalData.schedule_id)
					// this.confirmUserSchedule()
				}
			}
			else if(this.modalData && this.modalData.is_payment_request){
				window.open(this.modalData.redirect_payment_url, '_blank').focus();
			}
			else if(this.modalData && this.modalData.is_contract_payment_request){
				const url = 'https://apiarq.insomnia.cl/contract-confirm?ct=' + this.modalData.contract_id
				window.open(url, '_blank').focus();
			}
			this.closeModal(true)
		},
		async confirmUserSchedule(){
			const confirmation = await confirmUserSchedule({schedule_id: this.modalData.schedule_id})
			if(confirmation.code == 200){
				const messageData = {
					message: 'Se ha confirmado la Visita Técnica',
					title: 'Visita Técnica Confirmada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>